var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ItemForm',{staticClass:"py-2",attrs:{"item-id":_vm.localItemId,"loading":_vm.loadingForm,"editing":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }